import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { sendEmailURL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export enum EmailType {
    WELCOME = 'SendWelcomeEmail',
    AUTH_EMAIL = 'SendAuthEmail'
}

/**
 * Send an email to the user.
 *
 * @param userName - The username.
 * @param emailType - The email type to send.
 *
 * @returns - The JSON response.
 */
export const sendEmailForUser = (userName: string, emailType: EmailType): Promise<JSONResponse<void>> =>
    requestJSON(sendEmailURL(userName), {
        method: RESTMethods.PUT,
        body: {
            [emailType]: true
        }
    })
